import React from 'react';
import '../template-file-css/document-file-template.css';


export const NHBC_NursingFollowUp = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NHBC_NursingFollowUp' className='file-pdf-document'>

            <div className='file-template'> 

                    <p className='w-750'>
                        <span className='eleHeader'>Contact Type:</span>
                    </p>
                    <table>
                        <tr>
                            <td className='w-375'>
                                <input type="checkbox" name="cbFaceToFace" id="cbFaceToFace" className='add-only' value="FaceFace" />
                                Face to Face
                            </td>
                            <td className='w-375'>
                                <input type="checkbox" name="cbPhone" id="cbPhone" className='add-only' value="Phone" />
                                Phone
                            </td> 
                        </tr>
                        <tr> 
                            <td className='w-375'>
                                <input type="checkbox" name="cbOther" id="cbOther" className='add-only' value="Other" />
                                Other:
                                <input   type="text" id="txtContactOther" name="txtContactOther" className='add-only custom-add-only w-250' />
                            </td>
                        </tr>
                    </table>
                    <h4>LIVING ARRANGEMENTS</h4>
                    <table>
                        <tr>
                            <td className='w-250'>
                                <span className='eleHeader'>Number in Household:</span>
                                <input type='text' id="txtNumberInHousehold" name="txtNumberInHousehold" className='add-only' />
                            </td>
                            <td className='w-250'>
                                <span className='eleHeader'>Designated Caregiver:</span>
                                <input type='text' id="txtDesignatedCaregiver" name="txtDesignatedCaregiver" className='add-only' />
                            </td>
                            <td className='w-250'>
                                <span className='eleHeader'>Home Conditions:</span>
                                <select id="ddlHomeConditions" name="ddlHomeConditions" className='add-only'>
                                    <option value="Clean">Clean</option>
                                    <option value="Unclean">Unclean</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-250'>
                                <span className='eleHeader'>Safety:</span>
                                <select id="ddlSafety" name="ddlSafety" className='add-only'>
                                    <option value="Good">Good</option>
                                    <option value="Fair">Fair</option>
                                    <option value="Poor">Poor</option>
                                </select>
                            </td>
                            <td className='w-250'>
                                <span className='eleHeader'>Hygiene:</span>
                                <select id="ddlHygiene" name="ddlHygiene" className='add-only'>
                                    <option value="Good">Good</option>
                                    <option value="Fair">Fair</option>
                                    <option value="Poor">Poor</option>
                                </select>
                            </td>
                            <td className='w-250'>&nbsp;</td>
                        </tr>
                    </table>
                    <p className='w-750'>
                        <span className='eleHeader'>Comments:</span>
                        <textarea id="txtHygiene_Comments" name="txtHygiene_Comments" className='add-only'></textarea>
                    </p>

                    <h4>VITALS</h4>
                    <table>
                        <tr>
                            <td className='w-125'>
                                <span className='eleHeader'>Temp:</span>
                                <input type='text' id="txtVitals_Temp" name="txtVitals_Temp"  className='add-only' />
                            </td>
                            <td className='w-125'>
                                <span className='eleHeader'>Pulse</span>
                                <input type='text' id="txtVitals_Pulse" name="txtVitals_Pulse"  className='add-only' />
                            </td>
                            <td className='w-125'>
                                <span className='eleHeader'>Blood Pressure</span>
                                <input type='text' id="txtVitals_BloodPressure" name="txtVitals_BloodPressure"  className='add-only' />
                            </td>
                            <td className='w-125'>
                                <span className='eleHeader'>Respiration:</span>
                                <input type='text' id="txtVitals_Respiration" name="txtVitals_Respiration"  className='add-only' />
                            </td>
                            <td className='w-125'>
                                <span className='eleHeader'>Height</span>
                                <input type='text' id="txtVitals_Height" name="txtVitals_Height"  className='add-only' />
                            </td>
                            <td className='w-125'>
                                <span className='eleHeader'>Weight</span>
                                <input type='text' id="txtVitals_Weight" name="txtVitals_Weight"  className='add-only' />
                            </td>
                        </tr>
                    </table>

                    <h4>ALLERGIES</h4>
                    <table>
                        <tr>
                            <td className='w-375'>
                                <span className='eleHeader'>Medications:</span>
                                <input type='text' id="txtAllergies_Medications" name="txtAllergies_Medications" className='add-only' />
                            </td>
                            <td className='w-375'>
                                <span className='eleHeader'>Food:</span>
                                <input type='text' id="txtAllergies_Food" name="txtAllergies_Food" className='add-only' />
                            </td>
                        </tr>
                        <tr>
                            <td className='w-375'>
                                <span className='eleHeader'>Pollens:</span>
                                <input type='text' id="txtAllergies_Pollens" name="txtAllergies_Pollens" className='add-only' />
                            </td>
                            <td className='w-375'>
                                <span className='eleHeader'>Other:</span>
                                <input type='text' id="txtAllergies_Other" name="txtAllergies_Other" className='add-only' />
                            </td>
                        </tr>
                    </table>
                    <p className='w-750'>
                        <span className='eleHeader'>Comments:</span>
                        <textarea id="txtAllergies_Comments" name="txtAllergies_Comments" className='add-only'></textarea>
                    </p>

                    <h4>MEDICATIONS</h4>
                    <table>
                        <tr>
                            <td className='w-150'>Medication</td>
                            <td className='w-150'>Dosage</td>
                            <td className='w-150'>Frequency</td>
                            <td className='w-150'>Rx Date</td>
                            <td className='w-150'>Physician</td>
                        </tr>
                        <tr>
                            <td className='w-150'>
                                <input type='text' id="txtMedtn_MEDICATION1" name="txtMedtn_MEDICATION1" className='add-only'  />
                            </td>
                            <td className='w-150'>
                                <input type='text' id="txtMedtn_DOSAGE1" name="txtMedtn_DOSAGE1" className='add-only'  />
                            </td>
                            <td className='w-150'>
                                <input type='text' id="txtMedtn_FREQENCY1" name="txtMedtn_FREQENCY1" className='add-only'  />
                            </td>
                            <td className='w-150'>
                                <input type='text' id="txtMedtn_DtOfRX1" name="txtMedtn_DtOfRX1" className='add-only'  />
                            </td>
                            <td className='w-150'>
                                <input type='text' id="txtMedtn_PHYSICAN1" name="txtMedtn_PHYSICAN1" className='add-only'  />
                            </td>
                        </tr>
                        <tr>
                            <td className='w-150'>
                                <input type='text' id="txtMedtn_MEDICATION2" name="txtMedtn_MEDICATION2" className='add-only'  />
                            </td>
                            <td className='w-150'>
                                <input type='text' id="txtMedtn_DOSAGE2" name="txtMedtn_DOSAGE2" className='add-only'  />
                            </td>
                            <td className='w-150'>
                                <input type='text' id="txtMedtn_FREQENCY2" name="txtMedtn_FREQENCY2" className='add-only'  />
                            </td>
                            <td className='w-150'>
                                <input type='text' id="txtMedtn_DtOfRX2" name="txtMedtn_DtOfRX2" className='add-only'  />
                            </td>
                            <td className='w-150'>
                                <input type='text' id="txtMedtn_PHYSICAN2" name="txtMedtn_PHYSICAN2" className='add-only'  />
                            </td>
                        </tr>
                        <tr>
                            <td className='w-150'>
                                <input type='text' id="txtMedtn_MEDICATION3" name="txtMedtn_MEDICATION3" className='add-only'  />
                            </td>
                            <td className='w-150'>
                                <input type='text' id="txtMedtn_DOSAGE3" name="txtMedtn_DOSAGE3" className='add-only'  />
                            </td>
                            <td className='w-150'>
                                <input type='text' id="txtMedtn_FREQENCY3" name="txtMedtn_FREQENCY3" className='add-only'  />
                            </td>
                            <td className='w-150'>
                                <input type='text' id="txtMedtn_DtOfRX3" name="txtMedtn_DtOfRX3" className='add-only'  />
                            </td>
                            <td className='w-150'>
                                <input type='text' id="txtMedtn_PHYSICAN3" name="txtMedtn_PHYSICAN3" className='add-only'  />
                            </td>
                        </tr>
                        <tr>
                            <td className='w-150'>
                                <input type='text' id="txtMedtn_MEDICATION4" name="txtMedtn_MEDICATION4" className='add-only'  />
                            </td>
                            <td className='w-150'>
                                <input type='text' id="txtMedtn_DOSAGE4" name="txtMedtn_DOSAGE4" className='add-only'  />
                            </td>
                            <td className='w-150'>
                                <input type='text' id="txtMedtn_FREQENCY4" name="txtMedtn_FREQENCY4" className='add-only'  />
                            </td>
                            <td className='w-150'>
                                <input type='text' id="txtMedtn_DtOfRX4" name="txtMedtn_DtOfRX4" className='add-only'  />
                            </td>
                            <td className='w-150'>
                                <input type='text' id="txtMedtn_PHYSICAN4" name="txtMedtn_PHYSICAN4" className='add-only'  />
                            </td>
                        </tr>
                        <tr>
                            <td className='w-150'>
                                <input type='text' id="txtMedtn_MEDICATION5" name="txtMedtn_MEDICATION5" className='add-only'  />
                            </td>
                            <td className='w-150'>
                                <input type='text' id="txtMedtn_DOSAGE5" name="txtMedtn_DOSAGE5" className='add-only'  />
                            </td>
                            <td className='w-150'>
                                <input type='text' id="txtMedtn_FREQENCY5" name="txtMedtn_FREQENCY5" className='add-only'  />
                            </td>
                            <td className='w-150'>
                                <input type='text' id="txtMedtn_DtOfRX5" name="txtMedtn_DtOfRX5" className='add-only'  />
                            </td>
                            <td className='w-150'>
                                <input type='text' id="txtMedtn_PHYSICAN5" name="txtMedtn_PHYSICAN5" className='add-only'  />
                            </td>
                        </tr>
                    </table>

                    <p className='w-750'>
                        <span className='eleHeader'>Have there been any recent changes in medications?</span>
                        <input type="radio" id="rbChangesInMed_Yes" name="rbChangesInMed" className='add-only' value="Yes" /> Yes &nbsp;
                        <input type="radio" id="rbChangesInMed_No" name="rbChangesInMed" className='add-only' value="No" /> No, If yes, explain:<br />
                        <textarea id="txtChangesInMed_Explain" name="txtChangesInMed_Explain" className='add-only'></textarea>
                    </p>
                    <p className='w-750'>
                        <span className='eleHeader'>Is client compliant with medications?</span>
                        <input type="radio" id="rbCompliantWthed_Yes" name="rbCompliantWthed" className='add-only' value="Yes" /> Yes &nbsp;
                        <input type="radio" id="rbCompliantWthed_No" name="rbCompliantWthed" className='add-only' value="No" /> No, explain:<br />
                        <textarea id="txtCompliantWthed_Explain" name="txtCompliantWthed_Explain" className='add-only'></textarea>
                    </p>
                    <p className='w-750'>
                        <span className='eleHeader'>Efficacy of Current Medications</span>
                        <span className='small'>(Does current medications produce desired effect)</span>
                        <textarea id="txtEfficacyOfCurrentMedications" name="txtEfficacyOfCurrentMedications" className='add-only'></textarea>
                    </p>
                    <p className='w-750'>
                        <span className='eleHeader'>Previous Medications Used and reason(s) for discharge off of previous medications:</span>
                        <textarea id="txtPreMediUsedReason" name="txtPreMediUsedReason" className='add-only'></textarea>
                    </p>

                    <h4>PHYSICAL</h4>
                    <table>
                        <tr>
                            <td className='w-750'>
                                <span className='eleHeader'>Skin</span>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-300'>Jaundice</td>
                            <td className='w-75'>
                                <select id="ddlSkin_1" name="ddlSkin_1" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                            <td className='w-300'>Rash</td>
                            <td className='w-75'>
                                <select id="ddlSkin_2" name="ddlSkin_2" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-300'>Open Wounds</td>
                            <td className='w-75'>
                                <select id="ddlSkin_3" name="ddlSkin_3" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                            <td className='w-300'>Incision/Scars</td>
                            <td className='w-75'>
                                <select id="ddlSkin_4" name="ddlSkin_4" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-300'>Itching</td>
                            <td className='w-75'>
                                <select id="ddlSkin_5" name="ddlSkin_5" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                            <td className='w-300'>Tattoos</td>
                            <td className='w-75'>
                                <select id="ddlSkin_6" name="ddlSkin_6" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-300'>Edema</td>
                            <td className='w-75'>
                                <select id="ddlSkin_7" name="ddlSkin_7" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                            <td className='w-300'>Bruises</td>
                            <td className='w-75'>
                                <select id="ddlSkin_8" name="ddlSkin_8" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-300'>Hydrated</td>
                            <td className='w-75'>
                                <select id="ddlSkin_9" name="ddlSkin_9" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                            <td className='w-300'>Piercing</td>
                            <td className='w-75'>
                                <select id="ddlSkin_10" name="ddlSkin_10" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-300'>Observe any additional marks on ADM</td>
                            <td className='w-75'>
                                <select id="ddlSkin_11" name="ddlSkin_11" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                            <td className='w-300'>&nbsp;</td>
                            <td className='w-300'>&nbsp;</td>
                        </tr>
                    </table>
                    <p className='w-750'>
                        <span className='eleHeader'>Comments</span>
                        <textarea id="txtSkin_Comments" name="txtSkin_Comments" className='add-only'></textarea>
                    </p>
                    <table>
                        <tr>
                            <td className='w-750'>
                                <span className='eleHeader'>Mouth</span>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-300'>Retainers</td>
                            <td className='w-75'>
                                <select id="ddlMouth_1" name="ddlMouth_1" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                            <td className='w-300'>Bloody Gums</td>
                            <td className='w-75'>
                                <select id="ddlMouth_2" name="ddlMouth_2" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-300'>Toothache</td>
                            <td className='w-75'>
                                <select id="ddlMouth_3" name="ddlMouth_3" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                            <td className='w-300'>Braces</td>
                            <td className='w-75'>
                                <select id="ddlMouth_4" name="ddlMouth_4" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-300'>Cavities</td>
                            <td className='w-75'>
                                <select id="ddlMouth_5" name="ddlMouth_5" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                            <td className='w-300'>&nbsp;</td>
                            <td className='w-300'>&nbsp;</td>
                        </tr>
                    </table>
                    <p className='w-750'>
                        <span className='eleHeader'>Comments</span>
                        <textarea id="txtMouth_Comments" name="txtMouth_Comments" className='add-only'></textarea>
                    </p>
                    <table>
                        <tr>
                            <td className='w-750'>
                                <span className='eleHeader'>Eyes</span>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-300'>Contacts</td>
                            <td className='w-75'>
                                <select id="ddlEyes_1" name="ddlEyes_1" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                            <td className='w-300'>Glasses</td>
                            <td className='w-75'>
                                <select id="ddlEyes_2" name="ddlEyes_2" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-300'>Blurred Vision</td>
                            <td className='w-75'>
                                <select id="ddlEyes_3" name="ddlEyes_3" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                            <td className='w-300'>Redness</td>
                            <td className='w-75'>
                                <select id="ddlEyes_4" name="ddlEyes_4" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-300'>Inflammation</td>
                            <td className='w-75'>
                                <select id="ddlEyes_5" name="ddlEyes_5" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                            <td className='w-300'>&nbsp;</td>
                            <td className='w-300'>&nbsp;</td>
                        </tr>
                    </table>
                    <p className='w-750'>
                        <span className='eleHeader'>Comments</span>
                        <textarea id="txtEyes_Comments" name="txtEyes_Comments" className='add-only'></textarea>
                    </p>
                    <table>
                        <tr>
                            <td className='w-750'>
                                <span className='eleHeader'>Respiratory</span>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-300'>Wheezing</td>
                            <td className='w-75'>
                                <select id="ddlResp_1" name="ddlResp_1" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                            <td className='w-300'>Dyspnea</td>
                            <td className='w-75'>
                                <select id="ddlResp_2" name="ddlResp_2" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-300'>Hemoptysis</td>
                            <td className='w-75'>
                                <select id="ddlResp_3" name="ddlResp_3" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                            <td className='w-300'>Cough</td>
                            <td className='w-75'>
                                <select id="ddlResp_4" name="ddlResp_4" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-300'>Asthma</td>
                            <td className='w-75'>
                                <select id="ddlResp_5" name="ddlResp_5" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                            <td className='w-300'>Smoker</td>
                            <td className='w-75'>
                                <select id="ddlResp_6" name="ddlResp_6" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-300'>Other: <input type='text' id="txtResp_7" name="txtResp_7" className='add-only' /></td>
                            <td className='w-75'>
                                <select id="ddlResp_7" name="ddlResp_7" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                            <td className='w-300'>&nbsp;</td>
                            <td className='w-300'>&nbsp;</td>
                        </tr>
                    </table>
                    <p className='w-750'>
                        <span className='eleHeader'>Comments</span>
                        <textarea id="txtResp_Comments" name="txtResp_Comments" className='add-only'></textarea>
                    </p>
                    <table>
                        <tr>
                            <td className='w-750'>
                                <span className='eleHeader'>Cardiovascular</span>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-300'>High Blood Pressure</td>
                            <td className='w-75'>
                                <select id="ddlCardio_1" name="ddlCardio_1" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                            <td className='w-300'>Chest Pain</td>
                            <td className='w-75'>
                                <select id="ddlCardio_2" name="ddlCardio_2" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-300'>Palpitations</td>
                            <td className='w-75'>
                                <select id="ddlCardio_3" name="ddlCardio_3" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                            <td className='w-300'>Cardiac Surgery</td>
                            <td className='w-75'>
                                <select id="ddlCardio_4" name="ddlCardio_4" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-300'>Other: <input type='text' id="txtCardio_5" name="txtCardio_5" className='add-only' /></td>
                            <td className='w-75'>
                                <select id="ddlCardio_5" name="ddlCardio_5" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                            <td className='w-300'>&nbsp;</td>
                            <td className='w-300'>&nbsp;</td>
                        </tr>
                    </table>
                    <p className='w-750'>
                        <span className='eleHeader'>Comments</span>
                        <textarea id="txtCardio_Comments" name="txtCardio_Comments" className='add-only'></textarea>
                    </p>
                    <table>
                        <tr>
                            <td className='w-750'>
                                <span className='eleHeader'>Ears</span>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-300'>Hearing Difficulty</td>
                            <td className='w-75'>
                                <select id="ddlEars_1" name="ddlEars_1" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                            <td className='w-300'>Hearing Aid</td>
                            <td className='w-75'>
                                <select id="ddlEars_2" name="ddlEars_2" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-300'>Earaches</td>
                            <td className='w-75'>
                                <select id="ddlEars_3" name="ddlEars_3" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                            <td className='w-300'>Dizziness</td>
                            <td className='w-75'>
                                <select id="ddlEars_4" name="ddlEars_4" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-300'>Ringing</td>
                            <td className='w-75'>
                                <select id="ddlEars_5" name="ddlEars_5" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                            <td className='w-300'>&nbsp;</td>
                            <td className='w-300'>&nbsp;</td>
                        </tr>
                    </table>
                    <p className='w-750'>
                        <span className='eleHeader'>Comments</span>
                        <textarea id="txtEars_Comments" name="txtEars_Comments" className='add-only'></textarea>
                    </p>
                    <table>
                        <tr>
                            <td className='w-750'>
                                <span className='eleHeader'>GI/GU</span>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-300'>Abdominal Pain</td>
                            <td className='w-75'>
                                <select id="ddlGIUI_1" name="ddlGIUI_1" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                            <td className='w-300'>Heartburn</td>
                            <td className='w-75'>
                                <select id="ddlGIUI_2" name="ddlGIUI_2" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-300'>Constipation</td>
                            <td className='w-75'>
                                <select id="ddlGIUI_3" name="ddlGIUI_3" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                            <td className='w-300'>Diarrhea</td>
                            <td className='w-75'>
                                <select id="ddlGIUI_4" name="ddlGIUI_4" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-300'>Blood in Stool</td>
                            <td className='w-75'>
                                <select id="ddlGIUI_5" name="ddlGIUI_5" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                            <td className='w-300'>Painful Urination</td>
                            <td className='w-75'>
                                <select id="ddlGIUI_6" name="ddlGIUI_6" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-300'>Increase in Frequency</td>
                            <td className='w-75'>
                                <select id="ddlGIUI_7" name="ddlGIUI_7" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                            <td className='w-300'>Blood in Urine</td>
                            <td className='w-75'>
                                <select id="ddlGIUI_8" name="ddlGIUI_8" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                        </tr>
                    </table>
                    <p className='w-750'>
                        <span className='eleHeader'>Comments</span>
                        <textarea id="txtGIUI_Comments" name="txtGIUI_Comments" className='add-only'></textarea>
                    </p>
                    <table>
                        <tr>
                            <td className='w-750'>
                                <span className='eleHeader'>Nose and Throat</span>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-300'>Sinus Congestion</td>
                            <td className='w-75'>
                                <select id="ddlNT_1" name="ddlNT_1" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                            <td className='w-300'>Nose Bleeds</td>
                            <td className='w-75'>
                                <select id="ddlNT_2" name="ddlNT_2" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-300'>Sore Throat</td>
                            <td className='w-75'>
                                <select id="ddlNT_3" name="ddlNT_3" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                            <td className='w-300'>Difficulty Swallowing</td>
                            <td className='w-75'>
                                <select id="ddlNT_4" name="ddlNT_4" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                        </tr>
                    </table>
                    <p className='w-750'>
                        <span className='eleHeader'>Comments</span>
                        <textarea id="txtNT_Comments" name="txtNT_Comments" className='add-only'></textarea>
                    </p>
                    <table>
                        <tr>
                            <td className='w-750'>
                                <span className='eleHeader'>Reproductive</span>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-300'>Penile Discharge</td>
                            <td className='w-75'>
                                <select id="ddlRepro_1" name="ddlRepro_1" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                            <td className='w-300'>Penile Pain/Tenderness</td>
                            <td className='w-75'>
                                <select id="ddlRepro_2" name="ddlRepro_2" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-300'>Scrotal Pain/Swelling</td>
                            <td className='w-75'>
                                <select id="ddlRepro_3" name="ddlRepro_3" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                            <td className='w-300'>LMP</td>
                            <td className='w-75'>
                                <select id="ddlRepro_4" name="ddlRepro_4" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-300'>Breast Problems</td>
                            <td className='w-75'>
                                <select id="ddlRepro_5" name="ddlRepro_5" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                            <td className='w-300'>&nbsp;</td>
                            <td className='w-300'>&nbsp;</td>
                        </tr>
                    </table>
                    <p className='w-750'>
                        <span className='eleHeader'>Comments</span>
                        <textarea id="txtRepro_Comments" name="txtRepro_Comments" className='add-only'></textarea>
                    </p>
                    <table>
                        <tr>
                            <td className='w-750'>
                                <span className='eleHeader'>Neurological</span>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-300'>Headache</td>
                            <td className='w-75'>
                                <select id="ddlNeuro_1" name="ddlNeuro_1" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                            <td className='w-300'>Fainting</td>
                            <td className='w-75'>
                                <select id="ddlNeuro_2" name="ddlNeuro_2" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-300'>Convulsions</td>
                            <td className='w-75'>
                                <select id="ddlNeuro_3" name="ddlNeuro_3" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                            <td className='w-300'>Insomnia</td>
                            <td className='w-75'>
                                <select id="ddlNeuro_4" name="ddlNeuro_4" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-300'>Trembling</td>
                            <td className='w-75'>
                                <select id="ddlNeuro_5" name="ddlNeuro_5" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                            <td className='w-300'>Disoriented</td>
                            <td className='w-75'>
                                <select id="ddlNeuro_6" name="ddlNeuro_6" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-300'>Drug Use
                            <br/>Type: <input type='text' id="txtNeuro_7" name="txtNeuro_7" className='add-only custom-add-only w-200' /></td>
                            <td className='w-75'>
                                <select id="ddlNeuro_7" name="ddlNeuro_7" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                            <td className='w-300'>Alcohol Use
                            <br/>Type: <input type='text' id="txtNeuro_8" name="txtNeuro_8" className='add-only custom-add-only w-200' /></td>
                            <td className='w-75'>
                                <select id="ddlNeuro_8" name="ddlNeuro_8" className='add-only'>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </td>
                        </tr>
                    </table>
                    <p className='w-750'>
                        <span className='eleHeader'>Comments</span>
                        <textarea id="txtNeuro_Comments" name="txtNeuro_Comments" className='add-only'></textarea>
                    </p>
                    <h4>REFERRALS</h4>
                    <table>
                        <tr>
                            <td className='w-375'>
                                <input type="checkbox" id="cbReferals_MedicalFollowUp" name="cbReferals_MedicalFollowUp" className='add-only' value="Medical follow-up" />
                                Medical follow-up
                            </td>
                            <td className='w-375'>
                                <input type="checkbox" id="cbReferals_Alcohol" name="cbReferals_Alcohol" className='add-only' value="Referals_Alcohol" />
                                Alcohol/Substance Abuse Education
                            </td>
                        </tr>
                        <tr>
                            <td className='w-375'>
                                <input type="checkbox" id="cbReferals_MedicationEducation" name="cbReferals_MedicationEducation" className='add-only' value="Referals_MedicationEducation" />
                                Medication Education
                            </td>
                            <td className='w-375'>
                                <input type="checkbox" id="cbReferals_Fitness" name="cbReferals_Fitness" className='add-only' value="Referals_Fitness" />
                                Fitness and Nutrition Education
                            </td>
                        </tr>
                        <tr>
                            <td className='w-375'>
                                <input type="checkbox" id="cbReferals_HealthEducation" name="cbReferals_HealthEducation" className='add-only' value="Referals_HealthEducation" />
                                Health Education
                            </td>
                            <td className='w-375'>
                                <input type="checkbox" id="cbReferals_HIVAID" name="cbReferals_HIVAID" className='add-only' value="Referals_HIVAID" />
                                HIV/AIDS Education
                            </td>
                        </tr>
                        <tr>
                            <td className='w-375'>
                                <input type="checkbox" id="cbReferals_SexualEducation" name="cbReferals_SexualEducation" className='add-only' value="Referals_SexualEducation" />
                                Sexual Education
                            </td>
                            <td className='w-375'>
                                <input type="checkbox" id="cbReferals_HIVAIDSTesting" name="cbReferals_HIVAIDSTesting" className='add-only' value="Referals_HIVAIDSTesting" />
                                HIV/AIDS Testing/Treatment Referral
                            </td>
                        </tr>
                        <tr>
                            <td className='w-375'>
                                <input type="checkbox" id="cbReferals_ChronicDiseaseEducatn" name="cbReferals_ChronicDiseaseEducatn" className='add-only' value="Referals_ChronicDiseaseEducatn" />
                                Chronic Disease Education/Training
                            </td>
                            <td className='w-375'>
                                <input type="checkbox" id="cbReferals_ReferralToPrimary" name="cbReferals_ReferralToPrimary" className='add-only' value="Referals_ReferralToPrimary" />
                                Referral to primary care physician
                            </td>
                        </tr>
                        <tr>
                            <td className='w-750'>
                                <input type="checkbox" id="cbReferals_Other" name="cbReferals_Other" className='add-only' value="Referals_Other" />
                                Other:
                                <input type='text' id="txtReferalsOther" name="txtReferalsOther" className='add-only' />
                            </td>
                        </tr>
                    </table>
                    <h4>SUMMARY</h4>
                    <p className='w-750'>
                        <span className='eleHeader'>Summary</span>
                        <textarea id="txtSUMMARY" name="txtSUMMARY" className='add-only'></textarea>
                    </p>

                    <table>
                        <tr>
                            <td className='signature w-300'>&nbsp;
                            </td>
                            <td className='signature w-150'>&nbsp;
                            </td>
                            <td className='signature w-300'>&nbsp;
                            </td>
                        </tr>
                        <tr>
                            <td className='small w-300'>Nurse Signature/Credentials
                            </td>
                            <td className='small w-150'>Date
                            </td>
                            <td className='small w-300'>Please Type/Print Name and Credential
                            </td>
                        </tr>
                    </table> 

            </div>
        </form>

    )
} 
